import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=BUYBOX_EXP_4:control
// ?preferred_variant=BUYBOX_EXP_4:variant_1
// ?preferred_variant=BUYBOX_EXP_4:variant_2

export const BuyboxExp4Name = 'BUYBOX_EXP_4' as const;

export type BuyboxExp4Variants = ToVariants<typeof BuyboxExp4Variants>;

export const BuyboxExp4Variants = {
	/** Current BuyBox */
	// CONTROL: 'control',
	/** Last V2 (winner) with filter below promoted buybox */
	// VARIANT_1: 'variant_1',
	/** Free trial additions/changes */
	VARIANT_2: 'variant_2',
} as const;

// @ts-ignore disable control & v1
export default generate(BuyboxExp4Name, BuyboxExp4Variants);
